module.exports = __webpack_public_path__ + "src/img/tvIcon.b65518c5.svg";